import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
} from "@pimo/pimo-components/src/lib/pm-components";

import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addRatioOfCompletedItemsCard(ctx: DashboardCardContext) {
  const { view, language, projectName, projectNamePlural, getCardCopy } = ctx;

  const ratioOfCompletedItemsComponent = view.addComponent({
    component: PMSmallNumber,
  });

  ratioOfCompletedItemsComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "ratioOfCompletedItemsComponent",
      labels: ["#ofItems"],
      description: getCardCopy(language, "itemCompletionCounts").description,
      title: getCardCopy(language, "completionOfItems").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  ratioOfCompletedItemsComponent.mapState(({ dashboard, ...appState }) => {
    return {
      showInfoIcon: false,
      showMenuIcon: false,
      title: getLocalizedCardCopy(language, "completionOfItems", {
        itemName: getItemName(
          appState.settings?.configuration?.itemName,
          language
        ),
        itemNamePlural: getPluralOfItemName(
          appState.settings?.configuration?.itemName,
          language
        ),
        projectName,
        projectNamePlural,
      }).title,
      number: `${dashboard?._calculated?.numberOfClosedSubEntities ?? 0}/${
        dashboard?.projects?.flatMap((project) => project.reportingItems ?? [])
          .length ?? 0
      }`,
      description: getCardCopy(language, "itemCompletionCounts").description,
    };
  });

  ratioOfCompletedItemsComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
